var __rspack_ns_object = JSON.parse('{"Copied":"Kopiert","Failed to copy":"Kopieren fehlgeschlagen"}')